module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgcenter"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "img6",
      "src": "images/img6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The kind of image that helped the United States enter the war. Unrestricted submarine warfare and the loss of American lives caused a shift in opinion in the States. The original caption reads: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("These pictures just received in this country tell part of the story of the sinking of the French liner Sontay in the Mediterranean on 10 April with a loss of forty-five lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("THE NEW YORK TIMES MID-WEEK PICTORIAL WW1/US001")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-643ca264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/00d_AMERICAN_EXPEDITIONARY_FORCE.vue
// module id = 69
// module chunks = 0